import { useCallback, useRef } from "react";
import { useFormContext } from "react-hook-form";

import { AssignmentJourneyFormState } from "../types";

export function useAssignmentJourneyFormControls() {
  const {
    watch,
    control,
    setValue,
    register,
    handleSubmit,
    resetField,
    reset
  } = useFormContext<AssignmentJourneyFormState>();

  const formValues = watch();
  const previouslySelectedCourseIdRef = useRef(formValues.courseId);

  const setCourseId = useCallback(
    (courseId: string) => {
      if (courseId !== previouslySelectedCourseIdRef.current) {
        setValue("courseId", courseId);
        resetField("questionIds");
        resetField("courseContents");
        resetField("selectedWordIds");

        previouslySelectedCourseIdRef.current = courseId;
      }
    },
    [resetField, setValue]
  );

  return {
    formValues,
    setCourseId,
    setValue,
    control,
    register,
    handleSubmit,
    resetField,
    reset
  };
}
